<template>
  <div>
    <vue-apex-charts
      class="mt-6 mb-8"
      type="donut"
      :height="height"
      :options="options"
      :series="series"
      @dataPointSelection="emitClickSection"
    />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    VueApexCharts,
  },
  props: {
    chartId: {
      type: String,
      required: true,
    },
    series: {
      type: Array,
      default: function () {
        return []
      },
    },
    height: {
      type: String,
      default: '250',
    },
    lastYear:{
      type:String,
      default:'0'
    }
  },
  data() {
    return {
      options: {
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  fontSize: '24px',
                  color: '#000000',
                },
                name: {
                  show: true,
                  fontSize: '22px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  fontWeight: 600,
                  color: undefined,
                  offsetY: -10,
                },
                value: {
                  show: true,
                  fontSize: '16px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  fontWeight: 400,
                  color: '#5F6A6A',
                  offsetY: 16,
                },
              },
            },
          },
        },
        chart: {
          id: this.chartId,
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true | '<img src="/static/icons/reset.png" width="20">',
              customIcons: [],
            },
          },
        },
        tooltip: {
          enabled: true,
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            return `<div style="display:inline-flex">
                      <div class="circulo" style="background:${w.globals.fill.colors[seriesIndex]}"></div>
                      <div class="tooltip-label">
                        ${w.globals.labels[seriesIndex]}: $${series[seriesIndex].toLocaleString('en-US')}
                      </div>
                    </div>`
          },
        },
        legend: {
          show: false,
          position: 'bottom',
        },
        labels: ['Label'],
        dataLabels: {
          enabled: false,
        },
      },
    }
  },
  methods: {
    emitClickSection(event, chartContext, config) {
      this.$emit('clickDonutSection', config)
    },
  },

}

</script>

<style>
.circulo {
  position: relative;
  width: 12px;
  height: 12px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  top: 4px;
  margin-left: 3px;
}

.tooltip-label {
  margin-left: 3px;
  margin-right: 3px;
}
</style>
